var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1619.8,1345.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M806,1586.5c0,0-335.7-162.3-170.8-525.4c5.3-11.6,11.1-23,17.5-34C697.6,949,934.5,527.3,878,406.9 c0,0,435.8,157.3,278.5,789.6l-4.9,32.8c0,0,183.5-208.1,145.8-421c0,0,322.7,494.8-122.9,784.7c0,0,54.1-242.5,49.1-258.8 c0,0-121.7,83.6-137,85.2c-15.3,1.6-161.1-275.5-123.4-416.3C963.2,1003.1,655.2,1095,806,1586.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fire_icon.80b969034cb132a13817a87e80e0036b.svg";
export { ForwardRef as ReactComponent };